<template>
  <div class="container">
    <TopHeader title="我的报餐" returnPath="Home"></TopHeader>
    <div class="main-content">
      <div class="apply-btn" @click="toReport">报餐申请</div>

      <div class="main-list" v-if="list && list.length">
        <div v-for="(item, index) in list" :key="index" class="list-content">
          <div class="list-items">
            <div class="items-top">
              <div class="items-title">申请状态</div>
              <div
                class="item-status"
                :class="item.status === 1 ? 'agree' : 'refuse'"
              >
                {{ item.status === 1 ? '成功' : '取消' }}
              </div>
            </div>
            <CommonBorder></CommonBorder>
            <div class="items-content">
              <div class="items-title">报餐时间</div>
              <div class="items-text">{{ item.day }}</div>
            </div>
            <div class="items-content">
              <div class="items-title">报餐餐段</div>
              <div class="items-text">{{ getMealPeriod(item) }}</div>
            </div>
            <div class="items-content">
              <div class="items-title">申请时间</div>
              <div class="items-text">{{ item.createTime }}</div>
            </div>
            <div class="items-content">
              <div class="items-title">预付费用</div>
              <div class="items-text">
                ¥{{ Number(item.money / 100).toFixed(2) }}
              </div>
            </div>
            <div class="btn-content" v-if="item.status === 1">
              <div class="cancel-btn" @click="changeStatus(item)">取消</div>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-else
        description="暂无数据"
        :image="require('@/assets/apply-list-none.png')"
        style="padding-top: 40%"
        class="empty"
      />
    </div>
    <van-overlay :show="show">
      <van-loading color="#1989fa" />
    </van-overlay>
  </div>
</template>

<script>
import { getList, cancelApply, getReportMealTime } from '@/api/report-meal';
import cancel from '@/assets/cancel.png';
import TopHeader from '@/components/topHeader/index.vue';
import CommonBorder from '@/components/commonBorder/index.vue';
import dayjs from 'dayjs';

export default {
  name: 'MyReportMeal',
  components: {
    TopHeader,
    CommonBorder
  },
  data() {
    return {
      title: '',
      show: false,
      cancel,
      list: [],
      loading: false,
      finished: false,
      isClassManager: false,
      organizationId: null,
      reportMealTimeConfig: {}
    };
  },
  computed: {
    date() {
      return (day) => {
        if (day) {
          return day.substr(-8);
        } else {
          return '-';
        }
      };
    }
  },
  async created() {
    const organizationId = JSON.parse(
      sessionStorage.getItem('personInfo')
    ).organizationId;
    this.organizationId = organizationId;
    const { role } = this.$store.getters;
    this.title = role === 0 ? '主管' : '班主任';
    this.isClassManager = JSON.parse(
      sessionStorage.getItem('personInfo')
    ).isClassManager;
    // const { current, size } = this.pagination
    // if (this.isClassManager) {
    //   this.pagination.channel = 1;
    // }
    await this.getReportMealTimeConfig();
    await this.fetch();
  },
  methods: {
    toReport() {
      this.$router.push({
        name: 'ReportMealApply'
      });
    },
    async fetch() {
      const { list } = this;
      list.length === 0 && (this.show = true);
      const { code, data, message } = await getList();
      if (code === 0) {
        this.list = data;

        this.show = false;
      } else {
        console.log(message);
      }
    },
    toHome() {
      this.$router.push({ name: 'Home' });
    },
    onLoad() {
      const { current, size, total } = this.pagination;
      if (current * size >= total) {
        this.finished = true;
      } else {
        this.fetch({ current: current + 1, size });
      }
    },
    toBack() {
      this.$router.back();
    },
    // 获取餐段
    getMealPeriod(card) {
      const mealPeriodList = [];
      for (const key in card) {
        this.constant.SUBMIT_MEAL_PERIOD.forEach((item) => {
          if (item.value === key && card[key] === 1) {
            mealPeriodList.push(item.label);
          }
        });
      }
      return mealPeriodList.join('、');
    },
    // 更改状态
    async changeStatus(item) {
      const day = dayjs(item.day).format('YYYY-MM-DD');
      const now = new Date();
      const nowDate = dayjs(now).format('YYYY-MM-DD');
      const nowTime = dayjs(now).format('HH:mm:ss');
      if (day === nowDate) {
        let hasExpiredMeal = false;  // 餐段是否过期
        for (const key in item) {
          if (item[key] === 1) {
            let startTime, endTime;
            switch (key) {
              case 'breakfast':
                startTime = this.reportMealTimeConfig.breakfastStartTime;
                endTime = this.reportMealTimeConfig.breakfastEndTime;
                break;
              case 'lunch':
                startTime = this.reportMealTimeConfig.lunchStartTime;
                endTime = this.reportMealTimeConfig.lunchEndTime;
                break;
              case 'dinner':
                startTime = this.reportMealTimeConfig.dinnerStartTime;
                endTime = this.reportMealTimeConfig.dinnerEndTime;
                break;
              case 'night':
                startTime = this.reportMealTimeConfig.nightStartTime;
                endTime = this.reportMealTimeConfig.nightEndTime;
                break;
            }

            if (startTime && nowTime > startTime) {
              hasExpiredMeal = true;
              break;
            }
          }
        }

        if (hasExpiredMeal) {
          this.$toast('当前报餐中包含已过期的餐段，无法取消');
          return;
        }
      }
      try {
        this.show = true;
        const id = item.id;
        const res = await cancelApply({ id });
        if (res.code === 0 && res.data) {
          this.$toast('取消成功');
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.show = false;
        await this.fetch();
      }
    },

    async getReportMealTimeConfig() {
      const res = await getReportMealTime({
        organizationId: this.organizationId
      });
      if (res.code === 0) {
        this.reportMealTimeConfig = res.data;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  font-family: 'PingFangSC-Regular';
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f7f7;
  .main-content {
    flex: 1;
    width: 100%;
    overflow: auto;
    margin-top: 10px;
    padding: 0 16px;
    box-sizing: border-box;
    .apply-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      margin-bottom: 15px;
      width: 100%;
      height: 44px;
      background-color: #fa5050;
      color: #fff;
      border-radius: 4px;
    }
    .main-list {
      display: flex;
      flex-direction: column;
      .list-content {
        margin-bottom: 15px;
        .list-items {
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 10px;
          box-shadow: 0 0 0.875rem #dcdcdc;
          display: flex;
          flex-direction: column;
          .items-top {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            height: 50px;
            box-sizing: border-box;
            padding: 0 16px;
            .items-title {
              color: #333;
              font-weight: 700;
            }
            .item-status {
              height: 21px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              color: #fff;
              font-size: 13px;
              font-weight: 400;
              font-family: 'PingFangSC-Regular';
              box-sizing: border-box;
              padding: 4px 8px;
            }
            .agree {
              background: #00b893;
            }
            .refuse {
              background: #ffa900;
            }
          }
          .items-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            height: 44px;
            box-sizing: border-box;
            padding: 0 16px;
            .items-title {
              color: #333;
            }
            .items-text {
              color: #666;
              word-wrap: break-word; /* 或者使用 overflow-wrap: break-word; */
            }
          }
        }
      }
      .btn-content {
        box-sizing: border-box;
        padding: 0 16px;
        display: flex;
        justify-content: end;
        align-items: center;
        height: 60px;
        .cancel-btn {
          width: 77px;
          height: 33px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background-color: #fa5050;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
::v-deep .van-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
}

.empty {
  ::v-deep .van-empty__image {
    width: 280px;
    height: 150px;
  }
}
</style>
